import { MDBCheckbox, MDBTable, MDBTableBody, MDBTableHead } from 'mdb-react-ui-kit';
import { useContext, useEffect, useState } from 'react';
import { Button, Container } from 'react-bootstrap';
import api from '../../app/api/agent'
import { GlobalStateContext } from '../../store/GlobalState';
import CustomNavBar from '../../components/CustomNavBar';
//import Cookies from 'js-cookie';
import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { Alert, CircularProgress, Snackbar, Typography } from '@mui/material';
import SimpleDialogSuccess from '../../components/DialogSuccess';

function AlertEdit() {

    const [pageRecord, setPageRecord] = useState<Array<{ [x: string]: any }>[] | undefined>(undefined)
    const [recordList, setRecord] = useState<Array<{ [x: string]: any }>| undefined>(undefined)
    const [pageNum, setPageNum] = useState(1)
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [pageSize, setPageSize] = useState(10)
    const [TotalRecord, setTotalRecord] = useState(0)

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [searchParams, setSearchParams] = useSearchParams();
    const alertId = searchParams.get("alertId")

    
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const [userIdsList, setUserIdsList] = useState<string[]>([]);
    const [receiveList, setReceiveList] = useState<boolean[]>([]);

    const [openSuccess, setOpenSuccess] = useState(false);

    const globalState = useContext(GlobalStateContext);
    useEffect(()=>{

        if(localStorage.accessToken){
            api.get(`/Account/userInfo`).then((response)=>{
                    if (response.status !== 200){
                        localStorage.removeItem("accessToken")
                        localStorage.removeItem("refreshToken")
                        localStorage.removeItem("expireAt")
                        localStorage.removeItem("role")
                        globalState?.setAccessToken('');
                        window.location.href='/'
                    }else{
                      /* if(response.data.role.toString() !== "0"){
                          window.location.href='/'
                      } */
                    }
                    }).catch(()=>{
                        localStorage.removeItem("accessToken")
                        localStorage.removeItem("refreshToken")
                        localStorage.removeItem("expireAt")
                        localStorage.removeItem("role")

                        globalState?.setAccessToken('');
                        window.location.href='/'
                    })
        }else{
          api.get("/OIDC/getUserInfo",{withCredentials: true,}).then((response)=>{
                              if (response.status !== 200){
                                      window.location.href='/'
                              }else{
                                /* if(response.data.role.toString() !== "0"){
                                    window.location.href='/'
                                } */
                              }
                              }).catch(()=>{
                                  window.location.href='/'
                          })
        }
        if(localStorage.getItem("role") === "0"){
          getRecord()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[])

    useEffect(()=>{
        setPageNum(pageNum)
    },[pageNum])


    const getRecord=async ()=>{
      if(localStorage.accessToken){
        await api.get(`/Alert/receiver?alertId=${alertId}`).then((response)=>{
            if(response.data.length === 0){
                setTotalRecord(0);
            }else{
                setUserIdsAndReceiveList(response.data)
                setRecord(response.data)
                pageSeperate(response.data)
                setTotalRecord(response.data.length)
                setUserIdsAndReceiveList(response.data)
            }
        })
      }else{

        await api.get(`/Alert/receiver?alertId=${alertId}`,{withCredentials: true,}).then((response)=>{
            if(response.data.length === 0){
                setTotalRecord(0);
            }else{
              
                setUserIdsAndReceiveList(response.data)
                setRecord(response.data)
                pageSeperate(response.data)
                setTotalRecord(response.data.length)
            }
        })
      }
    }
    const pageSeperate = (records: Array<{ [x: string]: any }>) =>{
        var i = 0;
        var tempList: Array<{ [x: string]: any }>[] = []
        records?.forEach((record, index)=>{
            if(tempList[i] === undefined){tempList[i]=[]}
            tempList[i].push(record)
            if((index+1)%10 ===0){i+=1}
        })
        setPageRecord(tempList)
    }

    useEffect(()=>{
        //getRecord();
        if(pageRecord != null)
       setRecord(pageRecord[pageNum - 1])
    },[pageNum, pageRecord])

    const setUserIdsAndReceiveList = (records: Array<{ [x: string]: any }>) =>{
        var tempUserIdsList: string[] = []
        var tempReceiveList: boolean[] = []
        records?.forEach((record)=>{
            tempUserIdsList.push(record["userId"]);
            tempReceiveList.push(record["isReceive"]);
        })
        setUserIdsList(tempUserIdsList)
        setReceiveList(tempReceiveList)
    }

    const ReceivceOrNot = (recordIndex: number) =>{
        var tempList = receiveList;
        if(tempList[recordIndex] === false){
          tempList[recordIndex] = true
        }else{
          tempList[recordIndex] = false
        }
        setReceiveList(tempList)
    }

    const handleClickOpenSuccess = () => {
      setOpenSuccess(true);
    };

    const handleCloseSuccess = () => {
      setOpenSuccess(false);
      window.location.reload()
    };

    const Save = async() => {
      await setIsLoading(true);
      setError(null);

      if(localStorage.accessToken){
        await api.put(`/Alert/receiver`,{isReceive: receiveList, alertId: alertId!, userIds: userIdsList}).then((response)=>{
            if(response.status === 200){
              setIsLoading(false);
              handleClickOpenSuccess();
            }else{
              setIsLoading(false);
              setError("Failed to Save  \n保存失敗 \n")
            }
        })
      }else{

        await api.put(`/Alert/receiver`,{isReceive: receiveList, alertId: alertId!, userIds: userIdsList},{withCredentials: true,}).then((response)=>{
            if(response.status === 200){
              setIsLoading(false);
              handleClickOpenSuccess();
            }else{
              setIsLoading(false);
              setError("Failed to Save  \n保存失敗 \n")
            }
        })
      }
    }

  return (
    <Container className="table-responsive" style={{minWidth: "770px",padding: 0, fontFamily:"Poppins", width:"95%", height:"100vh", background:"linear-gradient(45deg,rgba(255, 255, 255, 1) 0%, rgba(245, 255, 247, 1) 50%, rgba(222, 255, 232, 1) 100%)"}}>
    <CustomNavBar></CustomNavBar>
    
    
    {localStorage.getItem("role") !== "0" && 
          <><div>404 not found</div></>
    }

    
    {localStorage.getItem("role") === "0" && 
          <>
        {isLoading && <div style={{position:"fixed", left:"0", top:"0", width:"100%", height:"100%", zIndex:"100", background:"rgba(0, 0, 0, 0.4)"}}></div>}
        {isLoading && <div style={{position: "fixed", top:"50%", right:"50%", zIndex:"10000"}}>
            <CircularProgress/>
        </div>}
        <div>
          <Button variant="outline-primary" onClick={()=>window.location.href='/alert/list'} style={{marginBottom: "20px"}}>
            Back
          </Button>
        </div>
    {/* <Table striped bordered hover responsive size='sm'> */}
    <MDBTable align='middle' className="table table-hover" style={{width:"95%", margin:"auto"}}>
      {/* <thead style={{borderBottom:"12px"}}> */}
      <MDBTableHead>
        <tr className='table-success'>
          <th>User Id</th>
          <th>User Name</th>
          <th>Receive or Not</th>
        </tr>
      {/* </thead> */}
      </MDBTableHead>
      <MDBTableBody>
      {/* <tbody> */}
      {recordList === undefined || recordList === null ? <></>: recordList.map((record, recordIndex)=>{
            return<React.Fragment key={record["userId"]}>
                <tr>
                <td>{record["userId"].toString()}</td>
                <td>{record["userName"].toString()}</td>
                <td>
                  <MDBCheckbox
                      id={'controlledCheckbox ' + record["userId"].toString()}
                      defaultChecked={receiveList[recordIndex + ((pageNum - 1) * pageSize)]}
                      onChange={() => ReceivceOrNot(recordIndex + ((pageNum - 1) * pageSize))}
                    />
                </td>
                </tr></React.Fragment>
      })}
      
      </MDBTableBody>
    </MDBTable>
    {/* </Table> */}
    <div style={{display:"flex", flexDirection:"row", justifyContent:"space-between", marginBottom:"20px"}}>
      <div style={{marginTop:"20px", textAlign:"left", width:"90%", display:"flex", flexDirection:"row", justifyContent:"left"}}>
        <Button variant="outline-primary" onClick={()=>Save()}>
            Save
        </Button>
      </div>
      <div style={{marginTop:"20px", textAlign:"right", width:"90%", display:"flex", flexDirection:"row", justifyContent:"right"}}>
          <div style={{marginRight:"30px"}}>
              {/* <span style={{fontSize:"20px", verticalAlign:"middle"}}>{pageNum+1}-{pageRecord? (pageRecord[pageNum] ? pageRecord[pageNum].length : 0) : recordList?.length} OF {recordList?.length}</span> */}
              <span style={{fontSize:"20px", verticalAlign:"middle"}}>{TotalRecord === 0? 0 : 1 + (pageNum -1)* pageSize}-{(TotalRecord/pageSize > pageNum)? (pageNum) * pageSize: TotalRecord} OF {TotalRecord}</span>
          </div>
          <button onClick={(e)=>{(1 < pageNum)? setPageNum(pageNum-1): setPageNum(pageNum)}} style={{width:"30px", height:"30px", cursor:"pointer"}}>&lt;</button>
          <button onClick={(e)=>{(TotalRecord/pageSize > pageNum)? setPageNum(pageNum+1): setPageNum(pageNum)}} style={{width:"30px", marginRight:"10px", height:"30px", cursor:"pointer"}}>&gt;</button>    
      </div>
    </div>
    <Snackbar
      open={!!error}
      autoHideDuration={6000}
      onClose={() => setError(null)}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
    >
      <Alert
        onClose={() => setError(null)}
        severity="error"
        variant="filled"
        sx={{ width: "100%" }}
      >
        <Typography variant="body2">
          {error && error.split('\n').map((line, index) => (
            <span key={index}>
              {line}
              <br />
            </span>
          ))}
        </Typography>
      </Alert>
    </Snackbar>

    <SimpleDialogSuccess openSuccess={openSuccess} handleCloseSuccess={handleCloseSuccess} messagetype='Alert'></SimpleDialogSuccess>
    </>
    }

    
      <div className='bar-styles'>
        Steel Bar Form System &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Version: {process.env.REACT_APP_VERSION}
        <div style={{float:'right', marginRight: '40px'}}>
        </div>
      </div>
    </Container>
  );
}

export default AlertEdit;